import AbilityParamsUtil from './AbilityParamsUtil';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import { Platfrom } from '../../utils/PlatformConstants';
import AppLinkStat from '../stats/AppLinkStat';
import { openStoreByPlatform } from '../../utils/StoreConfig';

const DEEPLINK_SCHEME = 'wpsoffice:';
const OLD_DEEPLINK_HOST = 'wps.cn';

function openWps() {
  const deeplinkUrl = translateApplink() as string;
  if (deeplinkUrl === undefined) {
    return;
  }
  window.location.href = deeplinkUrl;
}

function translateApplink() {
  if (DeviceEnvUtil.getPlatform() === Platfrom.IOS) {
    return translateOldIOSDeeplink();
  }

  return translateNewDeeplink();
}

function translateNewDeeplink() {
  const scheme = window.location.protocol;
  const url = window.location.href;
  return DEEPLINK_SCHEME + url.substring(scheme.length, url.length);
}

function download() {
  openStoreByPlatform(AbilityParamsUtil.getDownloadUrl());
  AppLinkStat.eventDownloadTrigger(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    AbilityParamsUtil.getDownloadChan(),
    DeviceEnvUtil.getPlatform(),
  );
}

function isHome() {
  const module = getModuleTag();
  return module === undefined;
}

function getModuleTag() {
  const ability = AbilityParamsUtil.getAbilityName();
  if (ability === undefined) {
    return undefined;
  } else {
    return '/' + ability;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function translateOldIOSOpenToolType(queries: Map<string, any>, type: number) {
  queries.delete('type');
  queries.set('type', type);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function translateOldIOSOpenToolAppId(queries: Map<string, any>, appid: string) {
  queries.delete('appid');
  queries.set('appid', appid);
}

function translateOldIOSDeeplink() {
  const url = window.location.href;
  let ability = '';
  let type = '';
  const getqyinfo = url.split('?')[1];
  if (getqyinfo === undefined) {
    return undefined;
  }
  const getqys = getqyinfo.split('&');
  const realQueries = new Map();
  for (let i = 0; i < getqys.length; i++) {
    const item = getqys[i].split('=');
    const key = item[0];
    const value = item[1];
    console.log('key: ' + key + ' -- value: ' + value);
    if (key === 'ability') {
      ability = value;
      continue;
    } else if (key === '_business_id') {
      type = value;
      continue;
    } else {
      realQueries.set(key, value);
    }
  }

  if (ability === '') {
    return undefined;
  }
  if (type === '') {
    type = 'new_unknown';
  }
  let path = '';
  if (ability === 'softbus') {
    const convertedUrl = translateNewDeeplink();
    return convertedUrl;
  }
  if (ability === 'face_look_doc') {
    const convertedUrl = translateNewDeeplink();
    return convertedUrl;
  }
  switch (ability) {
    case 'ocr_et':
      path = 'handle_req/utils/open_tool';
      translateOldIOSOpenToolType(realQueries, 35);
      break;
    case 'ocr_pdf':
      path = 'handle_req/utils/open_tool';
      translateOldIOSOpenToolType(realQueries, 32);
      break;
    case 'id_photo':
      path = 'handle_req/utils/open_miniprogram';
      translateOldIOSOpenToolAppId(realQueries, '26A31B5AD14C88931F106C99D14F4A7C');
      break;
    case 'tv_projection':
      path = 'handle_req/utils/open_tool';
      translateOldIOSOpenToolType(realQueries, 1);
      break;
    case 'share_play':
      path = 'handle_req/utils/open_tool';
      translateOldIOSOpenToolType(realQueries, 2);
      break;
    default:
      break;
  }
  if (path === '') {
    // AppLink统一后新增的ability，不在上述映射规则内
    if (DeviceEnvUtil.isWeixin()) {
      // 对Url进行转义
      const encodeUrl = encodeURIComponent(url);
      // 微信不支持打开scheme&&ulink域名目前只支持open-ios-app.wps.cn，所以采用折中拼接的方案，后续ability.wps.cn铺开后可去掉
      return 'https://open-ios-app.wps.cn/handle_req/applink_transfer?appLink=' + encodeUrl;
    } else {
      // 其他第三方App内转换成Deeplink唤起
      return translateNewDeeplink();
    }
  }
  let queryStr = '_z_b_f=' + type;
  for (const key of realQueries.keys()) {
    queryStr = queryStr + '&' + key + '=' + realQueries.get(key);
  }
  let retUrl = '';
  if (!DeviceEnvUtil.isWeixin()) {
    retUrl = DEEPLINK_SCHEME + '//' + OLD_DEEPLINK_HOST + '/' + path + '?' + queryStr;
  } else {
    retUrl = 'https://open-ios-app.wps.cn/' + path + '?' + queryStr;
  }
  return retUrl;
}

function getScheme() {
  return window.location.protocol;
}

export default {
  openWps,
  getModuleTag,
  isHome,
  getScheme,
  download,
  translateApplink,
  translateNewDeeplink,
  DEEPLINK_SCHEME,
};
